import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth';
import { setReceiveNewsletter } from './utils';

export default function* listenReceiveNewsletter() {
  yield takeEvery(actionTypes.setReceiveNewsletter.toString(), setReceiveNewsletter);
}
